import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 767px)";
const MOBILE_VIDEO = "/media/Main_Page_mobile.mp4";
const DESKTOP_VIDEO = "/media/Main_Page_opt.mp4";

/** Assign exactly one source after measuring the viewport, avoiding both downloads. */
export default function HomeHeroVideo({ className }) {
  const [src, setSrc] = useState();

  useEffect(() => {
    const query = window.matchMedia?.(MOBILE_QUERY);
    const update = () => setSrc(
      (query ? query.matches : window.innerWidth <= 767) ? MOBILE_VIDEO : DESKTOP_VIDEO
    );
    update();
    if (!query) {
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    }
    if (query.addEventListener) {
      query.addEventListener("change", update);
      return () => query.removeEventListener("change", update);
    }
    query.addListener(update);
    return () => query.removeListener(update);
  }, []);

  return (
    <video
      className={className}
      src={src}
      poster="/media/hero-poster.webp"
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      data-testid="home-hero-video"
    />
  );
}
